import { render } from "./MultiSelect.vue?vue&type=template&id=0b5841b0"
import script from "./MultiSelect.vue?vue&type=script&lang=ts"
export * from "./MultiSelect.vue?vue&type=script&lang=ts"

import "./MultiSelect.vue?vue&type=style&index=0&id=0b5841b0&lang=scss"
script.render = render

export default script